import React, {PropsWithChildren} from "react";


const SectionHeader:React.FunctionComponent<PropsWithChildren<any>> = ({children})=>{

    return <div className="relative mb-4">
        <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
        </div>
        <div className="relative flex items-center justify-between">
            <span className="bg-white pr-3 font-semibold leading-6 text-sm text-gray-800">{children}</span>
        </div>
    </div>
}

export default SectionHeader;